export default __webpack_public_path__ + "static/media/co-med-logo.0f68e7a4.jpg";